<div class="tw-bg-[#F8F9FB] tw-min-h-screen">
    <app-dashboard-wrapper>
        <div class="tw-flex tw-gap-[30px]">
            <div class="tw-flex-[3]">
                <div class="tw-block sm:tw-hidden">
                    <h2 class="!tw-font-bold">
                        {{ "COMMON.OVERVIEW" | translate }}
                    </h2>
                    <div
                        class="tw-flex tw-justify-between tw-items-center tw-rounded-[10px] tw-mb-5 tw-p-5 tw-bg-[linear-gradient(90deg,_#E8EDFF_0%,_#B1C2FF_100%)]"
                    >
                        <span class="!tw-font-bold !tw-text-sm !tw-m-0">
                            {{
                                "DASHBOARD.DASHBOARD_MAIN.SUBMIT_NEW_APP"
                                    | translate
                            }}
                        </span>
                        <button
                            ga-event-id="submit_new_application_button_dashboard_click"
                            ga-event-category="User Dashboard Button"
                            ga-event-label="Submit New Applications Button Click"
                            ga-track="track"
                            class="tw-py-[5px] tw-px-[15px] tw-min-w-[91px] tw-rounded-[100px] tw-bg-[#0A0A75] tw-text-sm tw-text-white tw-inline-block"
                            (click)="onSubmitNewApp()"
                        >
                            <span class="tw-inline-block md:tw-hidden">{{
                                "COMMON.APPLY" | translate
                            }}</span>
                        </button>
                    </div>
                </div>
                <!-- Overview of applications -->
                <div
                    class="tw-bg-white tw-shadow-lg tw-px-[26px] tw-py-[20px] lg:tw-px-[24px] tw-rounded-xl tw-mb-6 tw-gap-[14px] lg:tw-gap-[20px] tw-flex tw-flex-col"
                >
                    <!-- mobile only for overview -->
                    <div
                        class="tw-flex tw-justify-between md:tw-justify-start tw-items-center"
                    >
                        <span
                            class="!tw-font-semibold md:tw-text-[16px] lg:tw-text-[18px]"
                        >
                            {{ "COMMON.OVERVIEW" | translate }}
                        </span>
                        <button
                            class="tw-block md:tw-hidden tw-py-[5px] tw-px-[15px] tw-text-sm tw-rounded-full tw-bg-[#003A700F] tw-text-[#0A0A75]"
                            (click)="onViewMore()"
                        >
                            {{ "COMMON.VIEW_MORE" | translate }}
                        </button>
                    </div>
                    <!-- desktop and tablet view for overview -->
                    <div class="tw-flex tw-justify-between tw-items-center">
                        <div class="">
                            <div
                                class="tw-flex tw-flex-col md:tw-flex-row tw-text-center md:tw-text-left tw-gap-[8px] md:tw-gap-[2px]"
                            >
                                <img
                                    src="/assets/images/dashboard/icons/amount.svg"
                                    alt="Amount"
                                    class="tw-h-[30px] lg:tw-h-[50px] md:tw-h-auto"
                                />
                                <div
                                    class="tw-flex tw-flex-col tw-min-w-[140px] md:tw-min-w-[190px]"
                                >
                                    <span
                                        class="!tw-mb-1 tw-text-[12px] md:tw-text-[13px] lg:tw-text-[14px] tw-font-medium tw-text-[#000000E5] tw-max-w-[130px] lg:tw-max-w-fit tw-text-center"
                                    >
                                        {{
                                            "DASHBOARD.DASHBOARD_MAIN.FIN_AMOUNT_APPLIED"
                                                | translate
                                        }}
                                    </span>
                                    <span
                                        class="tw-text-[20px] md:tw-text-[30px] tw-text-[#22A447] tw-font-bold"
                                        >{{
                                            finAmountTotal == null
                                                ? "N/A"
                                                : (finAmountTotal
                                                  | currency
                                                      : "RM"
                                                      : true
                                                      : "1.0-0")
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="">
                            <div
                                class="tw-flex tw-flex-col md:tw-flex-row tw-text-center md:tw-text-left tw-gap-[8px] md:tw-gap-[2px]"
                            >
                                <img
                                    src="/assets/images/dashboard/icons/application.svg"
                                    alt="Application"
                                    class="tw-h-[30px] lg:tw-h-[50px] md:tw-h-auto"
                                />
                                <div
                                    class="tw-flex tw-flex-col tw-min-w-[140px] md:tw-min-w-[190px]"
                                >
                                    <span
                                        class="!tw-mb-1 tw-text-[12px] md:tw-text-[13px] lg:tw-text-[14px] tw-font-medium tw-text-[#000000E5] tw-max-w-[130px] lg:tw-max-w-fit tw-text-center"
                                    >
                                        {{
                                            "DASHBOARD.DASHBOARD_MAIN.TOTAL_APP_SUBMITTED"
                                                | translate
                                        }}
                                    </span>
                                    <span
                                        class="tw-text-[20px] md:tw-text-[30px] tw-text-[#FF8819] tw-font-bold"
                                        >{{
                                            applicationData.length ?? "N/A"
                                        }}</span
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="tw-hidden md:tw-block">
                            <button
                                class="tw-py-[10px] tw-px-[18px] tw-rounded-full tw-bg-[#003A700F] tw-text-[#0A0A75] tw-text-[12px]"
                                (click)="onViewMore()"
                            >
                                {{ "COMMON.VIEW_MORE" | translate }}
                            </button>
                        </div>
                    </div>
                </div>

                <!-- View More Products -->
                <div
                    class="tw-bg-white tw-shadow-lg tw-px-6 tw-py-7 tw-rounded-xl tw-mb-6"
                >
                    <p class="!tw-font-semibold !tw-mb-5 tw-text-[18px]">
                        {{
                            "DASHBOARD.DASHBOARD_MAIN.VIEW_MORE_PRODUCT"
                                | translate
                        }}
                    </p>
                    <div class="tw-grid tw-grid-cols-3 tw-gap-3">
                        <div
                            [attr.ga-event-id]="
                                item.ga_event_id + '_button_dashboard_click'
                            "
                            ga-event-category="User Dashboard Button"
                            [attr.ga-event-label]="
                                (item.name | translate) + ' Button Click'
                            "
                            ga-track="track"
                            *ngFor="let item of moreProducts"
                            class="tw-p-2 md:tw-p-5 tw-rounded-xl tw-flex tw-flex-col md:tw-flex-row tw-justify-center md:tw-justify-between tw-items-center tw-gap-0 md:tw-gap-[10px] tw-w-full tw-cursor-pointer"
                            [style.background]="item.bg"
                            (click)="onClickProducts(item.href)"
                        >
                            <img
                                class="tw-h-[50px] md:tw-h-auto tw-block md:tw-hidden"
                                alt="Dashboard Icon"
                                [src]="
                                    '/assets/images/dashboard/icons/' +
                                    item?.slug +
                                    '-mob.svg'
                                "
                            />
                            <span
                                class="tw-text-sm md:tw-text-[18px] tw-text-center md:tw-text-left tw-font-semibold tw-max-w-[102px]"
                                >{{ item.name | translate }}</span
                            >
                            <img
                                [src]="
                                    '/assets/images/dashboard/icons/' +
                                    item?.slug +
                                    '.svg'
                                "
                                class="tw-h-[50px] md:tw-h-auto tw-hidden md:tw-block"
                                alt="Dashboard Icon"
                            />
                        </div>
                    </div>
                </div>

                <!-- Application Table -->

                <div
                    class="tw-w-full tw-bg-white tw-shadow-lg tw-px-6 tw-py-7 tw-rounded-xl tw-mb-6"
                >
                    <div class="tw-flex tw-justify-between tw-items-center">
                        <p class="!tw-font-semibold tw-text-[18px]">
                            {{
                                "DASHBOARD.DASHBOARD_MAIN.APP_SUMMARY"
                                    | translate
                            }}
                        </p>

                        <button
                            class="tw-hidden md:tw-block tw-text-sm tw-py-2 tw-px-5 tw-rounded-full tw-text-[#4B6EEC] tw-border tw-border-[#4B6EEC]"
                            *ngIf="applicationData.length > 0 && apiResponse"
                            (click)="onViewMore()"
                        >
                            {{ "COMMON.VIEW_MORE" | translate }}
                        </button>
                    </div>

                    <div
                        class="tw-pb-10 tw-mt-8 tw-text-center"
                        *ngIf="applicationData.length == 0 && apiResponse"
                    >
                        {{ "COMMON.NO_RECORD" | translate }}
                    </div>

                    <table
                        class="tw-w-full tw-text-left tw-border-collapse"
                        *ngIf="applicationData.length > 0 && apiResponse"
                    >
                        <thead>
                            <tr
                                class="tw-text-gray-500 tw-text-sm tw-border-b tw-border-gray-200"
                            >
                                <th
                                    class="tw-pt-4 tw-pb-1 lg:tw-pb-4 tw-px-[2.55px] sm:tw-w-fit md:tw-w-[35%] tw-text-[12px] xl:tw-text-[14px] tw-font-normal tw-text-[#00000080]"
                                >
                                    {{ "COMMON.PRODUCT" | translate }}
                                </th>
                                <th
                                    class="tw-pt-4 tw-pb-1 lg:tw-pb-4 tw-px-[2.5px] tw-hidden md:tw-table-cell tw-w-[15%] tw-text-[12px] xl:tw-text-[14px] tw-font-normal tw-text-[#00000080] tw-text-center"
                                >
                                    {{ "COMMON.FINANCING_AMOUNT" | translate }}
                                </th>
                                <th
                                    class="tw-pt-4 tw-pb-1 lg:tw-pb-4 tw-px-[2.5px] tw-hidden md:tw-table-cell tw-w-[10%] tw-text-[12px] xl:tw-text-[14px] tw-font-normal tw-text-[#00000080]"
                                >
                                    {{
                                        "DASHBOARD.DASHBOARD_MAIN.DURATION"
                                            | translate
                                    }}
                                </th>
                                <th
                                    class="tw-pt-4 tw-pb-1 lg:tw-pb-4 tw-px-[2.5px] tw-hidden md:tw-table-cell tw-w-[20%] tw-text-center tw-text-[12px] xl:tw-text-[14px] tw-font-normal tw-text-[#00000080]"
                                >
                                    {{ "COMMON.DATE" | translate }}
                                </th>
                                <th
                                    class="tw-pt-4 tw-pb-1 lg:tw-pb-4 tw-px-[2.5px] !tw-w-[50%] lg:tw-w-[30%] tw-text-[12px] xl:tw-text-[14px] tw-font-normal tw-text-[#00000080] tw-text-start"
                                >
                                    {{ "COMMON.STATUS" | translate }}
                                </th>
                            </tr>
                        </thead>
                        <tbody class="tw-hidden md:tw-table-row-group">
                            <tr
                                *ngFor="
                                    let item of applicationData
                                        | slice : 0 : visibleApplicationCount
                                "
                                class="tw-text-black tw-border-b tw-border-gray-200"
                            >
                                <td
                                    class="tw-py-4 tw-px-[2.5px] tw-flex tw-flex-col tw-gap-[8px] tw-text-[13px] lg:tw-text-[14px] lg:tw-max-w-[200px] xl:tw-max-w-[260px] tw-leading-[18px]"
                                >
                                    <span
                                        class="tw-text-[14px] tw-text-[#00000080]"
                                        >{{ item.prodFinancialInst }}</span
                                    >
                                    <p
                                        class="!tw-font-semibold"
                                        *ngIf="item.productName !== null"
                                    >
                                        {{ item.productName }}
                                    </p>
                                    <span
                                        class="tw-py-[12px] tw-w-[135px] tw-px-[10px] tw-text-center tw-rounded-full tw-bg-[#0000000A] tw-text-[12px] tw-text-[#00000080]"
                                    >
                                        {{ "COMMON.RECENT_APPID" | translate }}:
                                        {{ item.cCaseAppNo }}</span
                                    >
                                </td>
                                <td
                                    class="tw-py-4 tw-px-[2.5px] tw-text-[13px] lg:tw-text-[14px] tw-text-center tw-leading-[18px] tw-align-top"
                                >
                                    {{
                                        item.cCaseFinamt
                                            | currency : "RM" : true : "1.0-0"
                                    }}
                                </td>
                                <td
                                    class="tw-py-4 tw-px-[2.5px] tw-text-[13px] lg:tw-text-[14px] tw-leading-[18px] tw-align-top tw-min-w-[100px]"
                                >
                                    <span class="tw-inline-block">
                                        <ng-container
                                            *ngIf="
                                                item.cCasePof !== 'TF' || 'RC'
                                            "
                                        >
                                            {{ item.cCaseTenure }}
                                        </ng-container>
                                        <span
                                            *ngIf="
                                                item.cCasePof == 'TF' || 'RC'
                                            "
                                        >
                                            {{
                                                item.cCaseTenureUnit
                                                    .split("-")
                                                    .slice(0, 2)
                                                    .join(" - ")
                                                    | uppercase
                                                    | translate
                                            }}
                                        </span>
                                        <span>&nbsp;</span>
                                        <span>{{
                                            item.cCaseTenureUnit
                                                .split("-")
                                                .slice(2)
                                                .join("")
                                                | uppercase
                                                | translate
                                        }}</span>
                                    </span>
                                </td>
                                <td
                                    class="tw-py-4 tw-px-[2.5px] tw-text-center tw-text-[13px] lg:tw-text-[14px] tw-leading-[18px] tw-align-top"
                                >
                                    {{ formatDate(item.updatedDateTime) }}<br />
                                    {{
                                        convertToTimeFormat(
                                            item.updatedDateTime
                                        )
                                    }}
                                </td>
                                <td
                                    class="tw-py-4 tw-px-[2.5px] tw-font-semibold tw-text-[13px] lg:tw-text-[14px] tw-leading-[18px] tw-text-start tw-align-top"
                                >
                                    <span
                                        *ngIf="
                                            (item.cCaseStatus
                                                .toLowerCase()
                                                .includes('uncontactable') ||
                                                item.cCaseStatus
                                                    .toLowerCase()
                                                    .includes('submission')) &&
                                                item.ccaseLabel === 'Close';
                                            else openCase
                                        "
                                    >
                                        {{ "COMMON.CASE_CLOSED" | translate }}
                                        <span
                                            [routerLink]="[
                                                '/business-financing'
                                            ]"
                                            [queryParams]="{
                                                matchingProduct: true
                                            }"
                                            class="tw-cursor-pointer tw-underline tw-text-blue-900"
                                        >
                                            {{
                                                "COMMON.SUBMIT_NEW_APPLICATION"
                                                    | translate
                                            }}
                                        </span>
                                    </span>

                                    <ng-template #openCase>
                                        <span>
                                            {{ item.cCaseStatus | translate }}
                                        </span>
                                    </ng-template>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- Show More Button for Desktop Table -->
                    <div
                        class="tw-hidden md:tw-flex tw-justify-center tw-mt-8"
                        *ngIf="visibleApplicationCount < applicationData.length"
                    >
                        <button
                            class="tw-bg-white tw-border tw-border-[#4B6EEC] tw-text-[#4B6EEC] tw-text-[14px] tw-leading-[16px] tw-font-semibold tw-px-5 tw-py-2 tw-rounded-[20px] tw-flex tw-items-center tw-justify-center tw-gap-2 hover:tw-bg-[#024B3F] hover:tw-text-white transition"
                            (click)="showMoreApplications()"
                        >
                            {{ "COMMON.VIEW_MORE" | translate }}
                        </button>
                    </div>

                    <div
                        *ngFor="
                            let item of applicationData
                                | slice : 0 : visibleApplicationCount
                        "
                        class="md:tw-hidden tw-grid tw-grid-cols-2 tw-gap-3 tw-text-black tw-border-b tw-border-gray-200 tw-py-[24px]"
                    >
                        <div class="tw-flex tw-flex-col tw-gap-1">
                            <span
                                class="tw-text-[12px] md:tw-text-[14px] tw-text-[#00000080]"
                                >{{ item.prodFinancialInst }}</span
                            >
                            <p
                                class="!tw-font-semibold !tw-text-sm md:!tw-text-[16px]"
                                *ngIf="item.productName !== null"
                            >
                                {{ item.productName }}
                            </p>
                            <span
                                class="tw-text-[11px] tw-py-[12px] tw-w-[135px] tw-px-[10px] tw-rounded-full tw-bg-[#0000000A] md:tw-text-[12px] tw-text-[#00000080] tw-text-center"
                            >
                                {{ "COMMON.RECENT_APPID" | translate }}:
                                {{ item.cCaseAppNo }}</span
                            >
                        </div>
                        <div
                            class="tw-font-semibold tw-text-[12px] md:tw-text-[14px] tw-text-start tw-max-w-[120px] tw-ml-auto"
                        >
                            <span
                                *ngIf="
                                    (item.cCaseStatus
                                        .toLowerCase()
                                        .includes('uncontactable') ||
                                        item.cCaseStatus
                                            .toLowerCase()
                                            .includes('submission')) &&
                                        item.ccaseLabel === 'Close';
                                    else openCase
                                "
                            >
                                {{ "COMMON.CASE_CLOSED" | translate }}
                                <span
                                    [routerLink]="['/business-financing']"
                                    [queryParams]="{ matchingProduct: true }"
                                    class="tw-cursor-pointer tw-underline tw-text-blue-900"
                                >
                                    {{
                                        "COMMON.SUBMIT_NEW_APPLICATION"
                                            | translate
                                    }}
                                </span>
                            </span>

                            <ng-template #openCase>
                                <span>
                                    {{ item.cCaseStatus | translate }}
                                </span>
                            </ng-template>
                        </div>
                        <div
                            class="tw-col-span-2 tw-grid tw-grid-cols-3 tw-gap-2"
                        >
                            <div class="tw-py-0">
                                <span
                                    class="tw-text-[10px] tw-font-normal tw-leading-[16px] tw-text-[#00000080]"
                                    >Financing Amount</span
                                >
                                <span class="tw-text-[13px]">
                                    {{
                                        item.cCaseFinamt
                                            | currency : "RM" : true : "1.0-0"
                                    }}
                                </span>
                            </div>
                            <div class="tw-py-0">
                                <span
                                    class="tw-text-[10px] tw-font-normal tw-leading-[16px] tw-text-[#00000080]"
                                    >Duration</span
                                >
                                <div class="tw-text-[13px]">
                                    <ng-container
                                        *ngIf="item.cCasePof !== 'TF' || 'RC'"
                                    >
                                        {{ item.cCaseTenure }}
                                    </ng-container>
                                    <span *ngIf="item.cCasePof == 'TF' || 'RC'">
                                        {{
                                            item.cCaseTenureUnit
                                                .split("-")
                                                .slice(0, 2)
                                                .join(" - ")
                                                | uppercase
                                                | translate
                                        }}
                                    </span>
                                    <span>&nbsp;</span>
                                    <span>{{
                                        item.cCaseTenureUnit
                                            .split("-")
                                            .slice(2)
                                            .join("")
                                            | uppercase
                                            | translate
                                    }}</span>
                                </div>
                            </div>
                            <div class="tw-py-0">
                                <span
                                    class="tw-text-[10px] tw-font-normal tw-leading-[16px] tw-text-[#00000080]"
                                    >Date</span
                                >
                                <div class="tw-text-[13px]">
                                    {{ formatDate(item.updatedDateTime) }}<br />
                                    {{
                                        convertToTimeFormat(
                                            item.updatedDateTime
                                        )
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Show More Button for Mobile Cards -->
                    <div
                        class="tw-flex md:tw-hidden tw-justify-center tw-mt-8"
                        *ngIf="visibleApplicationCount < applicationData.length"
                    >
                        <button
                            class="tw-bg-white tw-border tw-border-[#4B6EEC] tw-text-[#4B6EEC] tw-text-[14px] tw-leading-[16px] tw-font-semibold tw-px-5 tw-py-2 tw-rounded-[20px] tw-flex tw-items-center tw-justify-center tw-gap-2 hover:tw-bg-[#024B3F] hover:tw-text-white transition"
                            (click)="showMoreApplications()"
                        >
                            {{ "COMMON.VIEW_MORE" | translate }}
                        </button>
                    </div>
                </div>

                <!-- carousel -->
                <div
                    class="tw-block md:tw-hidden what-new tw-min-w-[100%] tw-w-[345px] tw-h-[270px] tw-mx-auto"
                >
                    <ngx-slick-carousel
                        class="carousel what-new tw-w-full"
                        [config]="slideConfig"
                        #slickCarousel
                    >
                        <div
                            ngxSlickItem
                            *ngFor="
                                let data of whatsNewData;
                                trackBy: trackByFn
                            "
                            class="slide tw-w-[385px]"
                        >
                            <div
                                class="tw-relative tw-cursor-pointer tw-w-[385px]"
                                (click)="viewWhatsNewDetails(data)"
                            >
                                <img
                                    [attr.ga-event-id]="
                                        data?.campaigndetails?.campaignName +
                                        '_whatsnew_card_dashboard_click'
                                    "
                                    ga-event-category="User Dashboard Button"
                                    [attr.ga-event-label]="
                                        data?.campaigndetails?.campaignName +
                                        ' What\'s New Card Click'
                                    "
                                    ga-track="track"
                                    [src]="
                                        data?.campaigndetails?.campaignImageUrl
                                    "
                                    alt="Whats New"
                                    class="tw-w-[385px] tw-h-[210px] tw-object-cover tw-rounded-[14px]"
                                />
                            </div>
                        </div>
                    </ngx-slick-carousel>
                </div>
            </div>
            <div class="tw-flex-1 tw-hidden md:tw-block">
                <div
                    class="tw-flex xl:tw-hidden tw-flex-col tw-gap-2 tw-p-4 tw-rounded-xl tw-border tw-border-[#FF8819] tw-mb-[18px] xl:tw-mb-0 tw-cursor-pointer"
                    (click)="onClickCompleteProfile()"
                    *ngIf="profileCompletionPercent < 100"
                >
                    <div
                        class="tw-flex tw-flex-row tw-justify-between tw-items-center"
                    >
                        <span class="!tw-text-sm">
                            {{ "DASHBOARD.COMPLETE_PROFILE" | translate }}
                        </span>
                        <img
                            src="assets/images/dashboard/icons/side-arrow.svg"
                            class="tw-h-[22px] tw-w-[22px]"
                        />
                    </div>

                    <mat-progress-bar
                        mode="determinate"
                        [value]="profileCompletionPercent"
                    ></mat-progress-bar>
                    <span class="tw-text-[18px] tw-font-semibold"
                        >{{ profileCompletionPercent }}%</span
                    >
                </div>
                <button
                    ga-event-id="submit_new_application_button_dashboard_click"
                    ga-event-category="User Dashboard Button"
                    ga-event-label="Submit New Applications Button Click"
                    ga-track="track"
                    class="tw-py-[14px] tw-px-[14px] tw-rounded-xl tw-mx-auto tw-flex tw-items-center tw-gap-2 tw-bg-[#4B6EEC] tw-text-white tw-mb-[18px] xl:tw-mb-[16px] tw-text-[14px] xl:tw-text-[16px]"
                    (click)="onSubmitNewApp()"
                >
                    <mat-icon>add</mat-icon>
                    {{ "DASHBOARD.DASHBOARD_MAIN.SUBMIT_NEW_APP" | translate }}
                </button>

                <div
                    class="what-new tw-w-[238px] xl:tw-w-[318px] tw-h-[270px] tw-mx-auto"
                >
                    <ngx-slick-carousel
                        class="carousel what-new tw-w-full"
                        [config]="slideConfig"
                        #slickCarousel
                    >
                        <div
                            ngxSlickItem
                            *ngFor="
                                let data of whatsNewData;
                                trackBy: trackByFn
                            "
                            class="slide tw-w-[238px] xl:tw-w-[318px]"
                        >
                            <div
                                class="tw-relative tw-cursor-pointer tw-w-[238px] xl:tw-w-[318px] tw-mx-auto"
                                (click)="viewWhatsNewDetails(data)"
                            >
                                <img
                                    [attr.ga-event-id]="
                                        data?.campaigndetails?.campaignName +
                                        '_whatsnew_card_dashboard_click'
                                    "
                                    ga-event-category="User Dashboard Button"
                                    [attr.ga-event-label]="
                                        data?.campaigndetails?.campaignName +
                                        ' What\'s New Card Click'
                                    "
                                    ga-track="track"
                                    [src]="
                                        data?.campaigndetails?.campaignImageUrl
                                    "
                                    alt="Whats New"
                                    class="tw-w-[238px] xl:tw-w-[318px] tw-h-[147px] xl:tw-h-[239px] tw-object-cover tw-rounded-[14px]"
                                />
                            </div>
                        </div>
                    </ngx-slick-carousel>
                </div>
            </div>
        </div>
    </app-dashboard-wrapper>
</div>
<app-loader [showLoader]="!apiResponse"></app-loader>
